import { render, staticRenderFns } from "./OrderErrorModal.vue?vue&type=template&id=06045441"
import script from "./OrderErrorModal.vue?vue&type=script&lang=ts"
export * from "./OrderErrorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports